import {post} from '@/common/utils/Http';

export default {
  loginCheck: post('/account/loginCheck'),
  getSyncStatus: post('/account/getSyncStatus'),
  upgradeCheck: post('/account/upgradeCheck'),
  getCrmLevel: post('/account/getCrmLevel'),
  getTime: post('/common/time'),
  hasRights: post('/account/hasRights'),
};
